import React from 'react'

import UserMenu from './header/UserMenu'
import Notifications from './header/Notifications'

import images from '../images'
import { AiOutlineMenu } from 'react-icons/ai'

const Header = ({ stations, setSidebarOpen, lockSession }) => (
    <header className="sticky top-0 bg-white border-b border-gray-200 z-30">
        <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16 -mb-px">

                {/* Header: Left side */}
                <div className="flex items-center">

                    {
                        stations?.length > 0 &&
                        <span className="text-xl px-2 mr-2 cursor-pointer" onClick={ setSidebarOpen }>
                            <AiOutlineMenu />
                        </span>
                    }
                    {/* Hamburger button */}
                    <img className="h-12" src={ images.logo } />
                </div>

                {/* Header: Right side */}
                <div className="flex items-center">

                    <Notifications />
                    {/*  Divider */}
                    <hr className="w-px h-6 bg-gray-200 mx-3" />
                    <UserMenu lockSession={ lockSession } />
                </div>

            </div>
        </div>
    </header>
)

export default Header